import { render, staticRenderFns } from "./QuestionnairePreview.vue?vue&type=template&id=b9889a56&scoped=true"
import script from "./QuestionnairePreview.vue?vue&type=script&lang=js"
export * from "./QuestionnairePreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionnairePreview.vue?vue&type=style&index=0&id=b9889a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9889a56",
  null
  
)

export default component.exports